// Will return the proxified url if necessary
// or the original url if not.
const getSearchFeedbackProxiedURL =
  (originalUrl, proxyUrl) => {
    try {
      const proxyURL = new URL(proxyUrl);
      const { pathname: proxyPathname } = proxyURL;

      const url = new URL(originalUrl);
      const { host, pathname, search } = url;

      proxyURL.pathname = `${proxyPathname}/${host}${pathname}`;
      proxyURL.search = search;

      return proxyURL.toString();
    } catch {
      // URL constructor will throw error if invalid URL is given.
      // Returning the originalUrl as a fallback in this case.
      return originalUrl;
    }
  };

module.exports = {
  getSearchFeedbackProxiedURL,
};
